import React from "react";
import Register from "./register";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import * as AccontAction from "../accountActions";

class RegisterForm extends React.Component {
  handleSubmit(values) {
    const { accountActions, history } = this.props;
    accountActions.onRegisterUser({
      name: values.name,
      email: values.email,
      password: values.password,
      navigation: history
    });
  }

  onLogin() {
    const { history } = this.props;
    history.push("/login");
  }
  render() {
    const { isLoading } = this.props;
    return (
      <Register
        onLogin={() => this.onLogin()}
        isLoading={isLoading}
        handleSubmitBtn={values => this.handleSubmit(values)}
      />
    );
  }
}

const mapStateToProps = ({ userAccount }) => {
  const { initiated, isLoading } = userAccount;
  return {
    initiated,
    isLoading
  };
};

const mapDispatchToProps = dispatch => ({
  accountActions: bindActionCreators(AccontAction, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RegisterForm));
